import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Button, Col, Container, Form, Modal, Row, } from "react-bootstrap";
import {Tooltip} from "@material-ui/core";
import Loader from "../Loader";
import {getSearchFormValuesByState} from "../../../helpers/configurationHelper";
import {AdvancedSearchConfigurationsType} from "../../../types/configurations";
import {ShapeType} from "../../../types/shape";
import {ProductImageStacType} from "../../../types/product";
import translations from "../../../translations";
import {DEFAULT_TOOLTIP_PROPS} from "../../../helpers/tooltipHelper";
import ApplicationService from "../../../services/ApplicationService";
import {errorToastNotification} from "../../../helpers/toastNotificationHelper";
import {getDownloadErrorMessageBy} from "../../../helpers/errorsHelper";

interface PropsType {
  language: string;
  searchFormValues: any;
  selectedProducts: ProductImageStacType[];
  selectedArea: ShapeType;
  configurations: AdvancedSearchConfigurationsType;
  handleClose: () => void;
  scopeConfigurationFields: string;
  formData: any;
  isInterferometricStackSearch: boolean;
  searchResults: any;
  lastShape: any;
}
const DownLoadSearchResultsModal = (props: PropsType) => {
  const {
    language,
    searchFormValues,
    selectedProducts,
    formData,
    handleClose,
    isInterferometricStackSearch,
    searchResults
  } = props;

  const [checkBoxValueList, setCheckBoxValueList] = useState<string[]>(["kml"]);
  const [aoiToogle, setAoiToogle] = useState(false);
  const [resultsToggle, setResultsToggle] = useState(true);
  const [selectedResults, setSelectedResults] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // defaults
    searchFormValues.formats = checkBoxValueList;
    searchFormValues.productIds = selectedProducts;
    searchFormValues.aoi = aoiToogle;

    if (formData.hasOwnProperty("missions")) {
      searchFormValues.missions = formData.missions;
    }
  }, [checkBoxValueList, selectedProducts, aoiToogle, searchFormValues.formats, searchFormValues.productIds, searchFormValues.aoi, searchFormValues.missions, formData, resultsToggle, searchFormValues.allResults, searchFormValues.selectedResults]);

  const HandleRadioFormats = (value) => {
    checkBoxValueList.pop();
    const checkElements = (element) => element == value;
    if (!checkBoxValueList.some(checkElements)) {
      setCheckBoxValueList([...checkBoxValueList, value]);
    }
  };

  const toggleResultsView = () => {
    if (selectedResults) {
      setSelectedResults(false);
      searchFormValues.allResults = false;
    } else {
      setSelectedResults(true);
      searchFormValues.allResults = true;
    }
  };

  const handleOptions = (e) => {
    const {value} = e.target;
    switch (value) {
      case "aoi":
        if (!aoiToogle) {
          setAoiToogle(true);
        } else {
          setAoiToogle(false);
        }
        break;
      case "results":
        toggleResultsView();
        if (e.target.checked) {
          setResultsToggle(true);
          searchFormValues.allResults = true;
          searchFormValues.selectedResults = false;
        } else {
          setResultsToggle(false);
          searchFormValues.allResults = false;
          searchFormValues.selectedResults = false;
        }
        break;
      case "allResults":
        searchFormValues.allResults = true;
        searchFormValues.selectedResults = false;
        break;
      case "selectedResults":
        searchFormValues.allResults = false;
        searchFormValues.selectedResults = true;
        break;
      case "csv":
        HandleRadioFormats(value);
        break;
      case "kml":
        HandleRadioFormats(value);
        break;
      case "shapefile":
        HandleRadioFormats(value);
        break;
      case "geojson":
        HandleRadioFormats(value);
        break;
    }
  };

  const donwloadResultsHandler = (e) => {
    setIsLoading(true);
    const url = `${process.env.REACT_APP_MAPIT}${process.env.REACT_APP_MAPIT_SEARCH}`;
    if (selectedProducts && selectedProducts.length) {
      searchFormValues.selectedProducts = selectedProducts;
    }
    const data = ApplicationService.searchDataJsonBuilder(searchFormValues, isInterferometricStackSearch);
    ApplicationService.downloadSearchResults(url, data)
      .then((response) => {
        return response.data.type !== "application/octet-stream" ? response.data.blob() : response.data;
      })
      .then((blob) => {
        const {type} = blob;
        if (type !== "application/octet-stream") {
          // catching the reasong for rejection
          throw new Error("");
        }
        let ext = "";
        switch (searchFormValues.formats[0]) {
          case "kml":
            ext = "kml";
            break;
          case "csv":
            ext = "csv";
            break;
          case "geojson":
            ext = "json";
            break;
          case "shapefile":
          default:
            ext = "zip";
        }
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `search_results.${ext}`;
        link.click();
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        errorToastNotification(getDownloadErrorMessageBy(err, language));
      })
      // .finally(() => {
      //   handleClose(); // chiudo la modale
      // });
  };

  const modalBody = (
    <Container>
      <p>{translations("downloadComponents", language)}</p>
      <hr />
      <Form>
        <Row>
          <Col>
            <Form.Check
              type="checkbox"
              id="aoi"
              label={translations("aoi", language)}
              value="aoi"
              onChange={handleOptions}
              className="checkbox"
            />
            <Form.Check
              type="radio"
              label={translations("downloadResultsCheckbox", language)}
              id="results"
              onChange={handleOptions}
              value="results"
              defaultChecked
            />
          </Col>
          <Col>
            { resultsToggle ? (
              <div>
                <Form.Check
                  type="radio"
                  id="allResults"
                  name="results"
                  label={translations("downloadResultsRadio", language)}
                  value="allResults"
                  onClick={handleOptions}
                  disabled={!resultsToggle}
                  defaultChecked
                />
                <Form.Check
                  type="radio"
                  id="Sresults"
                  name="results"
                  value="selectedResults"
                  label={translations(
                    "downloadSelectedResultsResultsRadio",
                    language
                  )}
                  onClick={handleOptions}
                  disabled={!selectedProducts || selectedProducts.length < 1}
                />
              </div>
            ) : null}
          </Col>
        </Row>
        <Row>
          <Col className="mt-4 mr-3">
            <p>{translations("outputFormats", language)}</p>
            <hr style={{ width: "222%", marginRight: "30%" }} />
            <div>
              <Form.Check
                type="radio"
                name="formats"
                id="kml"
                label="KML"
                value="kml"
                onClick={handleOptions}
                defaultChecked
              />
              <Form.Check
                disabled={false}
                type="radio"
                name="formats"
                label="Shapefile"
                value="shapefile"
                id="shapefile"
                onClick={handleOptions}
              />
              <Form.Check
                type="radio"
                id="csv"
                name="formats"
                label="CSV"
                value="csv"
                onClick={handleOptions}
              />
              <Form.Check
                disabled={false}
                type="radio"
                name="formats"
                label="GeoJSON"
                value="geojson"
                id="geoJson"
                onClick={handleOptions}
              />
            </div>
          </Col>
          <Col />
        </Row>
      </Form>
    </Container>
  );
  let buttonContext;
  if (isLoading) {
    buttonContext = <Loader spinnerClassName="button-size" />;
  } else {
    const buttonText = translations("downloadResultsButton", language);
    buttonContext = <span>{buttonText}</span>;
  }

  return (
    <div>
      <Modal show animation centered onHide={handleClose}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>{translations("downloadResults", language)}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{modalBody}</Modal.Body>
        <Modal.Footer>
          <Tooltip
            id=""
            {...DEFAULT_TOOLTIP_PROPS}
            title={translations("downloadResultsButtonTooltip", language)}
            placement="top"
          >
            <span>
              <Button
                disabled={isLoading || (!aoiToogle && !resultsToggle)}
                onClick={donwloadResultsHandler}
              >
                {buttonContext}
              </Button>
            </span>
          </Tooltip>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  configurations: state.application.configurations,
  selectedArea: state.geoMap.lastShape,
  searchResults: state.product.searchResults,
  selectedProducts: state.product.selectedProducts,
  searchFormValues: {
    ...getSearchFormValuesByState(state),
    ...state.application.searchFiltersSelected,
  },
  isInterferometricStackSearch: state.product.isInterferometricStackSearch,
  language: state.application.appParameters.language,
  searchByProducts: state.geoMap.searchByProducts
});

export default connect(
  mapStateToProps
)(DownLoadSearchResultsModal);
